import { useEffect } from "react";
import { usePreferences } from "./use-preferences";

// GAP-AUDIT-3 D9 — make the saved preferences actually DO something.
//
// The Hesap & ayarlar screen persisted five switches through
// PUT /v1/me/preferences and NOTHING in either app read them back. The
// accessibility trio in particular is a promise the product could keep entirely
// on the client — "Hareketi azalt", "Yüksek kontrast" and "Yazı boyutu" need no
// endpoint, only a class on the document — so leaving them inert was a plain
// lie to a person who may have set them because they need them.
//
// This hook applies the three that are honestly client-side, as data attributes
// on <html>, and styles.css keys off them. The other two are handled where they
// belong: the notification severity floor filters the Bildirimler feed at the
// point of render, and `defaultScope` stays labelled as a stored preference
// because no read accepts a scope parameter yet (backlog A4) — we do not pretend
// otherwise.

/** Applies the caller's accessibility preferences to the document root.
 *  Mounted once from the shell; a failed/absent preferences read is a NO-OP
 *  (the app keeps its defaults) rather than an error the advisor must clear. */
export function useApplyPreferences(): void {
  const { data } = usePreferences();
  const reducedMotion = data?.accessibility?.reducedMotion ?? false;
  const highContrast = data?.accessibility?.highContrast ?? false;
  const fontScale = data?.accessibility?.fontScale ?? "normal";

  useEffect(() => {
    const root = globalThis.document?.documentElement;
    if (!root) return;
    root.dataset.reducedMotion = reducedMotion ? "on" : "off";
    root.dataset.contrast = highContrast ? "high" : "normal";
    root.dataset.fontScale = fontScale;
  }, [reducedMotion, highContrast, fontScale]);
}
